import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from 'src/services/api.service';
import { UiEventService } from 'src/services/ui-event.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { goToLoginIfNotLoggedIn } from '../../services/ObservableExtension';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navbar-side',
  templateUrl: './navbar-side.component.html',
  styleUrls: ['./navbar-side.component.scss']
})
export class NavbarSideComponent implements OnInit {

  scopes: any = [];

  dashboards: any = [];

  currentScopeName: string = '';

  user: any;

  isPlatformAdmin = false;

  isCollapsed = true;

  defaultLogoURL = "assets/img/Logo-IQWS.png";

  modal: NgbModalRef;
  @ViewChild('notificationModal')
  notificationModal: ElementRef;
  hasNotifications = false;
  notifications: any = [];
  userNotifications: any = [];

  constructor(
    private api: ApiService,
    private ngbModal: NgbModal,
    private uiEvents: UiEventService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document) {
    this.api.brandColor = "#00e6e6";
  }

  ngOnInit() {
    var brandImage = document.getElementById("brandImage") as HTMLImageElement;
    brandImage.src = this.defaultLogoURL;

    this.api.get('provider/brandingInformation').subscribe((res: any) => {
      if (res.LogoUrl) {
        brandImage.src = res.LogoUrl;
      }
      if (res.BrandColor) {
        //this.api.brandColor = res.BrandColor;
        this.writeCorporateStyles();
      }
    });

    this.user = {
      FirstName: this.api.userFirstName,
      LastName: this.api.userLastName,
      IsPlatformAdmin: this.api.isPlatformAdmin
    };

    // this.getNotifications();
  }

  getNotifications() {
    this.api.get("notifications?raisedOnly=false&count=20").pipe(goToLoginIfNotLoggedIn(this.router)).subscribe((response: any) => {
      this.getUserNotifications();
      this.notifications = response;
      if (this.notifications && this.notifications.length) {
        this.hasNotifications = true;
      }
    });
  }

  getUserNotifications() {
    this.api.get("userNotifications").pipe(goToLoginIfNotLoggedIn(this.router)).subscribe((response: any) => {
      this.userNotifications = response;
      if (this.userNotifications && this.userNotifications.length) {
        this.hasNotifications = true;
      }
      if (this.hasNotifications) {
        this.modal = this.ngbModal.open(this.notificationModal, { size: 'lg' });
      }
    });
  }

  logout() {
    this.api.logout().subscribe(() => {
      this.api.brandColor = this.api.brandColorDefault;
      this.writeCorporateStyles();
      this.router.navigateByUrl('/login');
    });
  }

  writeCorporateStyles() {

    var styleElement = this.document.createElement('style');
    styleElement.type = 'text/css';
    var css = '';

    //header
    css += '.header-cont { background-color: ' + this.api.brandColor + '; border-color: ' + this.api.brandColor + '; } \n';

    //radio button
    css += '.custom-control-input:checked ~ .custom-control-label::before { background-color: ' + this.api.brandColor + ' !important; } \n';

    //chevron
    css += '.btn-link { color: ' + this.api.brandColor + ' !important; } \n';

    //anchor
    css += 'a.hover { color: ' + this.api.brandColor + '; } \n';

    //button-primary
    css += '.btn-primary { background-color: ' + this.api.brandColor + '; border-color: ' + this.api.brandColor + '; } \n';
    css += '.btn-primary:hover { background-color: ' + this.api.brandColor + '; border-color: ' + this.api.brandColor + '; } \n';
    css += '.btn-primary:not(:disabled):not(.disabled):active { background-color: ' + this.api.brandColor + '; border-color: ' + this.api.brandColor + '; } \n';
    css += '.btn-primary:focus { box-shadow: 0 0 0 0.2rem ' + this.api.brandColor + '; } \n';

    //btn-outline-primary
    css += '.btn-outline-primary { border-color: ' + this.api.brandColor + '; color: ' + this.api.brandColor + '; } \n';
    css += '.btn-outline-primary:hover { background-color: ' + this.api.brandColor + '; border-color: ' + this.api.brandColor + '; } \n';
    css += '.btn-outline-primary:not(:disabled):not(.disabled):active { background-color: ' + this.api.brandColor + '; border-color: ' + this.api.brandColor + '; } \n';
    css += '.btn-outline-primary:focus { box-shadow: 0 0 0 0.2rem ' + this.api.brandColor + '; } \n';

    //daterange-picker
    //css += '.md-drppicker .ranges ul li button.active { background-color: ' + this.api.brandColor + '; } \n';
    css += '.md-drppicker .ranges ul li button.active { background-color: #00e6e6; } \n';
    css += '.md-drppicker td.active, .md-drppicker td.active:hover { background-color: ' + this.api.brandColor + '; } \n';
    css += '.md-drppicker .btn:hover { background-color: ' + this.api.brandColor + '; } \n';
    css += '.md-drppicker .btn { background-color: ' + this.api.brandColor + '; } \n';

    styleElement.appendChild(document.createTextNode(css));

    var head = document.getElementsByTagName('head')[0];
    head.appendChild(styleElement);

  }

  onClickOpenNotification() {
    this.modal = this.ngbModal.open(this.notificationModal, { size: 'lg' });
  }

}
